import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { providePrimeNG } from 'primeng/config';
import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

import { routes } from './app.routes';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { errorInterceptor } from './core/interceptors/error.interceptor';

// Aura preset re-themed to the Trendly brand purple (#7B2FF7) instead of PrimeNG's default green.
const TrendlyPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50:  '#F6EEFE',
      100: '#EDDCFD',
      200: '#DBB8FC',
      300: '#C08FFA',
      400: '#A366F9',
      500: '#7B2FF7',
      600: '#6620DE',
      700: '#5419B5',
      800: '#43138F',
      900: '#330E6C',
      950: '#21094A',
    },
    colorScheme: {
      light: {
        // Aura's default rgba(0,0,0,.4) loading mask flashed a dark layer over the My Aideos
        // table on every search/filter/page change.
        mask: { background: 'rgba(255,255,255,0.6)', color: '{surface.500}' },
      },
    },
  },
});

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor, errorInterceptor])),
    provideAnimations(),
    // darkModeSelector: false — the app is light-only. PrimeNG's default ('system') switched its
    // components to the dark scheme on dark-mode OSes, rendering e.g. the My Aideos table rows
    // near-black against the app's light styles.
    providePrimeNG({ theme: { preset: TrendlyPreset, options: { darkModeSelector: false } } }),
  ],
};
